---
id: 'openpipe-coreweave'
title: 'OpenPipe is Joining CoreWeave'
excerpt: 'OpenPipe is joining CoreWeave; we’ll continue supporting ART and managed SFT workflows.'
date: 'Sep 3, 2025'
category: 'News'
readTime: '4'
author: 'Kyle Corbitt'
featured: true
draft: false
---

## **OpenPipe is Joining CoreWeave**

Hi everyone, this is Kyle with OpenPipe. We have a major announcement to make: OpenPipe is joining [CoreWeave](https://www.coreweave.com/)!

If you’re one of our hundreds of existing customers, don’t worry, we’ll continue supporting you! The plan is to **continue to develop our [ART](https://github.com/OpenPipe/ART) library and support SFT workflows** as part of CoreWeave’s mission to build the right infrastructure and tools to serve AI workloads at every level of abstraction.

Over the last two years we’ve helped our customers achieve state-of-the-art performance and reliability while saving millions of dollars by moving to smaller, faster, more reliable models. We’ve built one of the most popular libraries for training agents with reinforcement learning, which we’re improving daily. And along the way we’ve built a team of world-class researchers and engineers who have out-shipped and out-competed companies many times our size.

Together with the recently acquired [Weights & Biases](https://wandb.ai/) team and the broader CoreWeave organization, we are building a world-class unified platform for training, evaluating and observing AI models. We will continue pushing the frontier on model customization, contributing to open research, releasing cutting-edge open source libraries, and building products that make all of the above easier to use.

I’ve grown close to many members of the Weights & Biases team over the two years we’ve been working at OpenPipe, and been consistently impressed with their product sense and clear vision. As I’ve met more of the broader CoreWeave team as well, I’ve been inspired by their mission and ambition. Together, we’ll achieve great things!

We’ve barely scratched the surface of what RL can do, and in the coming months we’ll be moving even faster. If you have questions about this news I’d love to hear from you. We’re looking forward to sharing more about what that future looks like soon.

## **FAQs**

**What will happen with the SFT platform?**

We’ll continue maintaining managed SFT workflows as part of CoreWeave. The product may evolve, but we’ll continue improving on the key functionality.

**What will happen with Agent Reinforcement Trainer (ART)?**

We have exciting plans in the works for ART. We’ll continue pushing hard in this area and believe that improvements should come even faster going forward.

**How does this affect OpenPipe’s future vision?**

We’ll continue pushing the frontier on model customization, now with even more resources. You should expect us to continue contributing to open research, releasing cutting-edge open source libraries, and building products that make all of the above easier to use.

Learn more in the official press release [here](https://www.coreweave.com/news/coreweave-to-acquire-openpipe-leader-in-reinforcement-learning).
